import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledButton,
  StyledButtonsContainer,
  StyledCapacitiesCollapse,
  StyledContent,
  StyledIcon,
  StyledLabel,
  StyledRichText,
} from './CapacitiesCollapse.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import CKEditorContent from '../CKEditorContent/CKEditorContent'

const CapacitiesCollapse = (props) => {
  const {active, buttons, setActive, textHtml, title} = props

  return (
    <StyledCapacitiesCollapse>
      <StyledButton
        $active={active}
        onClick={setActive}
        variant={ButtonVariantEnum.quinary}
      >
        <StyledLabel>{title}</StyledLabel>
        <StyledIcon $active={active}/>
      </StyledButton>
      {active && (
        <StyledContent>
          {textHtml && (
            <StyledRichText>
              <CKEditorContent html={textHtml.content}/>
            </StyledRichText>
          )}
          {buttons && (
            <StyledButtonsContainer>{buttons}</StyledButtonsContainer>
          )}
        </StyledContent>
      )}
    </StyledCapacitiesCollapse>
  )
}

CapacitiesCollapse.propTypes = {
  buttons: PropTypes.array,
  text: PropTypes.object,
  title: PropTypes.string.isRequired,
}

export default CapacitiesCollapse
